import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { PiePlot } from "@/tools/pie-chart/components/PiePlot";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.donut_tool_name()}
        toolPath="/donut-chart"
      />
      <SciHeader title={m.donut_h1()} intro={m.donut_intro()} />

      <PiePlot donut />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.donut_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.donut_ex1(), m.donut_ex2(), m.donut_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.donut_faq_q1(), a: m.donut_faq_a1() },
          { q: m.donut_faq_q2(), a: m.donut_faq_a2() },
          { q: m.donut_faq_q3(), a: m.donut_faq_a3() },
          { q: m.donut_faq_q4(), a: m.donut_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
